export const ArticleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 19"
    aria-hidden="true"
    role="presentation"
    width={24}
    height={24}
  >
    <path
      d="M6.74,7.5H13V5.91H6.74Zm8-2.39a.84.84,0,0,0-.88-.79h-8A.84.84,0,0,0,5,5.11V8.3a.84.84,0,0,0,.88.79h8a.84.84,0,0,0,.88-.79ZM5,11.71a.84.84,0,0,1,.88-.8h8a.8.8,0,1,1,0,1.59h-8A.84.84,0,0,1,5,11.71Zm0,3.18a.84.84,0,0,1,.88-.8h8a.8.8,0,1,1,0,1.59h-8A.84.84,0,0,1,5,14.89ZM3.47,18.18H16.53V1.82H3.47ZM17.53,0H2.47a1,1,0,0,0-1,.91V19.09a1,1,0,0,0,1,.91H17.53a1,1,0,0,0,1-.91V.91A1,1,0,0,0,17.53,0Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
)
export default ArticleSvg
